import React, { Component } from 'react';
import styled from 'styled-components';

const ModalWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9800;
  opacity: 1;
  overflow-x: hidden;
  overflow-y: auto;
`;

const ModalCard = styled.div`
  border-radius: 1rem;
  border: 1px solid black;
  padding: 1rem;
  z-index: 9900;
  width: ${p => (p.width ? p.width : '420px')};
  min-height: ${p => (p.height ? p.height : '60px')};
  max-height: 90vh;
  background-color: ${p => p.theme.colors.white};
  margin: 0 auto;
  align-self: center;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalTitle = styled.h6`
  margin: 0;
  color: red;
`;

export default class ModalWarning extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return this.props.show ? (
      <ModalWrapper>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', top: '0', right: '0', left: '0', bottom: '0'}}>
          <img src="/images/Alert.gif" alt="" width="600px" height="600px" />
        </div>
        <ModalCard width={this.props.width} height={this.props.height} style={{position:'relative', top:'-50px'}}>
          <ModalHeader>
            <ModalTitle>
              <span style={{marginLeft:'15px'}}>
                Warning! Rural Properties May Not Be Supported.
              </span>
            </ModalTitle>
            <button
              type="button"
              className="btn-close"
              onClick={this.props.onDecline}
              aria-label="Close"
            ></button>
          </ModalHeader>
        </ModalCard>
      </ModalWrapper>
    ) : (
      <></>
    );
  }
}
